import React, { useEffect, useState } from "react"
import * as api from '../../../../Auth/auth'

import Mikrochartdiversity from "./MicroChart";


function GetMicro_2() {

       const [data, setData] = useState([])
       //const [data2, setData2] = useState([])
      

      useEffect(() => {

        async function axios_get() {
            const response = await api.micro()
            const microValue = response
            setData(microValue);
            
            getLatestDataset()

            }
    
        axios_get()
         
        }, []);
        
// "data1" is an array with one or more datasets - depending on number of microbiome samples of the user --> get the latest if there are more than 1
let latest= []
function getLatestDataset() {
    
    if (data.length) {
        latest = (data.reduce((m,v,i) => (v.id > m.id) && i ? v : m).id)-1 
        
        setData(data[latest]);
   }
 }

 // data structure what is needed for pie chart:
 //const data = [
 //   {id: 0, value: 55.39, label: "Bacteroidetes"},
 //   {id: 1, value: 36.24, label: "Firmicutes"},
 //   {id: 2, value: 5.99, label: "Proteobacteria"},
 //   {id: 3, value: 1.76, label: "Actinobacteria"},
 //   {id: 4, value: 0.62, label: "Verrucomicrobia"}
//]

//var res = Object.keys(data)
  // iterate over them and generate the array
//  .map(function(k) {
    // generate the array element 
//    return [+k, data[k]];
//  });

//console.log(res.slice(3,8))
 /*
 const names = ["Bacteroidetes", "Firmicutes", "Proteobacteria", "Actinobacteria", "Verrucomicrobia"]
 const values = [data.data[0].Bacteroidetes, data.data[0].Firmicutes, data.data[0].Proteobacteria, data.data[0].Actinobacteria, data.data[0].Verrucomicrobia]
 const rawdata = [
     {name: names[0], value: values[0]},
     {name: names[1], value: values[1]},
     {name: names[2], value: values[2]},
     {name: names[3], value: values[3]},
     {name: names[4], value: values[4]}
 ]
 const piedata = rawdata
 */
 //console.log(data)

    return (
    
             <>
                    <Mikrochartdiversity data={data}  /> 
                    
             </>          
            
    )
}

export default GetMicro_2;

